import { render } from "./Write.vue?vue&type=template&id=11187fbc&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"

import "./Write.vue?vue&type=style&index=0&id=11187fbc&scoped=true&lang=css"

import exportComponent from "D:\\WORKSPACE\\Netbeans\\lz06\\2022xiongmao\\xiongmao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11187fbc"]])

export default __exports__